
 const initialState = {
  productDetails:'' 
} 

export default function productListView( state = initialState, action) {
if(action.type==='Product_Details'){
    return {
      ...state,
      productDetails:action.payload,
    }
  }
  return state; 

}


